export default __webpack_public_path__ + "static/media/forgot_password.769ba6a4.svg";